<mat-form-field class="param-value" appearance="outline" subscriptSizing="dynamic">
  <input class="param-value__input truncate" matInput [value]="value()" [title]="value()" readonly disabled />
  @if (suffix(); as suffix) {
    <span class="param-value__suffix" matSuffix>{{ suffix }}</span>
  }
</mat-form-field>
